export const authConstansts = {
    USER_LOGIM_REQUEST           : 'USER_LOGIM_REQUEST',
    USER_LOGIM_SUCCESS           : 'USER_LOGIM_SUCCESS',
    USER_LOGIM_FAILURE           : 'USER_LOGIM_FAILURE',

    USER_LOGOUT_REQUEST          : 'USER_LOGOUT_REQUEST',
    USER_LOGOUT_SUCCESS          : 'USER_LOGOUT_SUCCESS',
    USER_LOGOUT_FAILURE          : 'USER_LOGOUT_FAILURE',
};

export const userConstants = {
    GET_REALTIME_USERS_REQUEST   : 'GET_REALTIME_USERS_REQUEST',
    GET_REALTIME_USERS_SUCCESS   : 'GET_REALTIME_USERS_SUCCESS',

    GET_REALTIME_MESSAGES_SUCCESS: 'GET_REALTIME_MESSAGES_SUCCESS',
    GET_REALTIME_MESSAGES_FAILURE: 'GET_REALTIME_MESSAGES_FAILURE',

    UPDATE_MESSAGES_SUCCESS      : 'UPDATE_MESSAGES_SUCCESS',
    SUBMIT_DONUT_SUCCESS         : 'SUBMIT_DONUT_SUCCESS',
};

export const relationConstants = {
    GET_USERINFO_REQUEST         : 'GET_USERINFO_REQUEST',
    GET_USERINFO_SUCCESS         : 'GET_USERINFO_SUCCESS',
    GET_USERINFO_FAILURE         : 'GET_USERINFO_FAILURE',

    SEND_REQUEST_REQUEST         : 'SEND_REQUEST_REQUEST',
    SEND_REQUEST_SUCCESS         : 'SEND_REQUEST_SUCCESS',
    SEND_REQUEST_FAILURE         : 'SEND_REQUEST_FAILURE',

    ACCEPT_REQUEST_REQUEST       : 'ACCEPT_REQUEST_REQUEST',
    ACCEPT_REQUEST_SUCCESS       : 'ACCEPT_REQUEST_SUCCESS',
    ACCEPT_REQUEST_FAILURE       : 'ACCEPT_REQUEST_FAILURE',

    GET_REQ_REQUEST              : 'GET_REQ_REQUEST',
    GET_REQ_ING_SUCCESS          : 'GET_REQ_ING_SUCCESS',
    GET_REQ_TED_SUCCESS          : 'GET_REQ_TED_SUCCESS',
    GET_REQ_FAILURE              : 'GET_REQ_FAILURE',
};